// this file contains all constants in the app
export const kNavBarHeight: number = 56;
export const folderLogoUri: string = "/folder-logo.png";